import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CKEditor from "react-ckeditor-component";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePolicy,
  getPoliciesAdmin,
  savePolicy,
} from "../../../store/actions/councilActions/policyAction";
import { getTrades } from "../../../store/actions/councilActions/trade";
import { errorAlert } from "../../../utils/alert";

const EMPTY = { title: "", trade_id: "", content: "", is_active: 1 };

const PolicyList = () => {
  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state);
  const { trades } = admin;

  const [list, setList] = useState(null);
  const [form, setForm] = useState(null); // null = closed
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setList(null);
    setList(await dispatch(getPoliciesAdmin()));
  };

  useEffect(() => {
    if (!trades) dispatch(getTrades());
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return errorAlert("Please write a title.");
    if (!String(form.content).trim())
      return errorAlert("Please write the policy content.");

    setBusy(true);
    const body = new FormData();
    Object.entries(form).forEach(([k, v]) => {
      if (k !== "id") body.append(k, v === null ? "" : v);
    });
    const done = await dispatch(savePolicy(body, form.id));
    setBusy(false);
    if (done) {
      setForm(null);
      load();
    }
  };

  const remove = async (row) => {
    if (!window.confirm(`Delete "${row.title}"? This cannot be undone.`)) return;
    if (await dispatch(deletePolicy(row.id))) load();
  };

  return (
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="BigTitle">Policies</div>
        <button
          type="button"
          class="btn btn-comman"
          onClick={() => setForm({ ...EMPTY })}
        >
          Add Policy
        </button>
      </div>

      <div class="table-responsive mt-3">
        <table class="table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Title</th>
              <th>Trade</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {list === null ? (
              <tr>
                <td colSpan={5}>Loading...</td>
              </tr>
            ) : list.length === 0 ? (
              <tr>
                <td colSpan={5}>No policy found.</td>
              </tr>
            ) : (
              list.map((row, i) => (
                <tr key={row.id}>
                  <td>{i + 1}</td>
                  <td>{row.title}</td>
                  <td>{row.trade?.name || "General (all)"}</td>
                  <td>
                    {Number(row.is_active) === 1 ? (
                      <span class="text-success">Active</span>
                    ) : (
                      <span class="text-muted">Hidden</span>
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary mr-1"
                      onClick={() =>
                        setForm({
                          id: row.id,
                          title: row.title || "",
                          trade_id: row.trade_id || "",
                          content: row.content || "",
                          is_active: Number(row.is_active),
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      onClick={() => remove(row)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Modal show={!!form} onHide={() => setForm(null)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{form?.id ? "Edit Policy" : "Add Policy"}</Modal.Title>
        </Modal.Header>
        {form && (
          <form onSubmit={submit}>
            <Modal.Body>
              <div class="row">
                <div class="col-md-8 mb-2">
                  <label>Title *</label>
                  <input
                    type="text"
                    class="form-control"
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                    required
                  />
                </div>
                <div class="col-md-4 mb-2">
                  <label>Trade (related course)</label>
                  <select
                    class="form-control"
                    value={form.trade_id}
                    onChange={(e) =>
                      setForm({ ...form, trade_id: e.target.value })
                    }
                  >
                    <option value="">General (all trades)</option>
                    {(trades || []).map((t) => (
                      <option value={t.id} key={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div class="col-md-4 mb-2">
                  <label>Status</label>
                  <select
                    class="form-control"
                    value={form.is_active}
                    onChange={(e) =>
                      setForm({ ...form, is_active: Number(e.target.value) })
                    }
                  >
                    <option value={1}>Active (show on website)</option>
                    <option value={0}>Hidden</option>
                  </select>
                </div>
                <div class="col-md-12 mb-2">
                  <label>Policy Content *</label>
                  <CKEditor
                    activeClass="p10"
                    config={{ versionCheck: false }}
                    content={form.content}
                    events={{
                      change: (evt) =>
                        setForm((f) => ({ ...f, content: evt.editor.getData() })),
                      blur: (evt) =>
                        setForm((f) => ({ ...f, content: evt.editor.getData() })),
                    }}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                class="btn btn-secondary"
                onClick={() => setForm(null)}
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-comman" disabled={busy}>
                {busy ? "Saving..." : "Save"}
              </button>
            </Modal.Footer>
          </form>
        )}
      </Modal>
    </div>
  );
};

export default PolicyList;
